"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWhitelistSync = exports.useHasClaimed = exports.useClaim = exports.useIsAddressVerified = exports.useFVLink = void 0;
var core_1 = require("@usedapp/core");
var ethers_1 = require("ethers");
var lodash_1 = require("lodash");
var react_1 = require("react");
var storage_1 = require("../storage");
var react_use_promise_1 = __importDefault(require("react-use-promise"));
var useRefreshOrNever_1 = __importDefault(require("../../hooks/useRefreshOrNever"));
var react_2 = require("../base/react");
var constants_1 = require("../constants");
var lodash_2 = require("lodash");
var useGasFees_1 = require("../base/hooks/useGasFees");
var useFVLink = function useFVLink(chainId) {
  var _ref = (0, react_2.useGetEnvChainId)(),
    defaultChainId = _ref.chainId;
  var sdk = (0, react_2.useSDK)(false, "claim", chainId !== null && chainId !== void 0 ? chainId : defaultChainId);
  return (0, react_1.useMemo)(function () {
    return sdk === null || sdk === void 0 ? void 0 : sdk.getFVLink(chainId);
  }, [sdk, chainId]);
};
exports.useFVLink = useFVLink;
var useIsAddressVerified = function useIsAddressVerified(address, env) {
  var sdk = (0, react_2.useReadOnlySDK)("claim");
  var result = (0, react_use_promise_1.default)(function () {
    if (address && sdk) return sdk.isAddressVerified(address);
    return Promise.resolve(undefined);
  }, [address, env, sdk]);
  return result;
};
exports.useIsAddressVerified = useIsAddressVerified;
var useClaim = function useClaim() {
  var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "never";
  var _a, _b, _c, _d;
  var refreshOrNever = (0, useRefreshOrNever_1.default)(refresh);
  var DAY = 1000 * 60 * 60 * 24;
  var _ref2 = (0, core_1.useEthers)(),
    account = _ref2.account;
  var _ref3 = (0, react_2.useGetEnvChainId)(),
    chainId = _ref3.chainId;
  var ubi = (0, react_2.useGetContract)("UBIScheme", true, "claim", chainId);
  var identity = (0, react_2.useGetContract)("Identity", true, "claim", chainId);
  var claimCall = (0, useGasFees_1.useContractFunctionWithDefaultGasFees)(ubi, "claim");
  var results = (0, core_1.useCalls)([identity && account && {
    contract: identity,
    method: "isWhitelisted",
    args: [account]
  }, ubi && {
    contract: ubi,
    method: "currentDay",
    args: []
  }, ubi && {
    contract: ubi,
    method: "periodStart",
    args: []
  }, ubi && account && {
    contract: ubi,
    method: "checkEntitlement(address)",
    args: [account]
  }], {
    refresh: refreshOrNever,
    chainId: chainId
  });
  var periodStart = (0, lodash_1.first)((_a = results[2]) === null || _a === void 0 ? void 0 : _a.value) || ethers_1.BigNumber.from("0");
  var currentDay = (0, lodash_1.first)((_b = results[1]) === null || _b === void 0 ? void 0 : _b.value) || ethers_1.BigNumber.from("0");
  var startRef = new Date(periodStart.toNumber() * 1000 + currentDay.toNumber() * DAY);
  if (startRef < new Date()) {
    startRef = new Date(periodStart.toNumber() * 1000 + (currentDay.toNumber() + 1) * DAY);
  }
  return {
    isWhitelisted: (0, lodash_1.first)((_c = results[0]) === null || _c === void 0 ? void 0 : _c.value),
    claimAmount: (0, lodash_1.first)((_d = results[3]) === null || _d === void 0 ? void 0 : _d.value) || undefined,
    claimTime: startRef,
    claimCall: claimCall
  };
};
exports.useClaim = useClaim;
var useHasClaimed = function useHasClaimed(requiredNetwork) {
  var _ref4 = (0, core_1.useEthers)(),
    account = _ref4.account;
  var ubi = (0, react_2.useGetContract)("UBIScheme", true, "claim", constants_1.SupportedV2Networks[requiredNetwork]);
  var _ref5 = (0, core_1.useCalls)([{
      contract: ubi,
      method: "checkEntitlement(address)",
      args: [account]
    }], {
      refresh: "never",
      chainId: constants_1.SupportedV2Networks[requiredNetwork]
    }),
    _ref6 = _slicedToArray(_ref5, 1),
    hasClaimed = _ref6[0];
  return (0, lodash_1.first)(hasClaimed === null || hasClaimed === void 0 ? void 0 : hasClaimed.value);
};
exports.useHasClaimed = useHasClaimed;
// if user is verified on fuse and not on current network then send backend request to whitelist
var syncInProgress = false;
var useWhitelistSync = function useWhitelistSync() {
  var _ref7 = (0, react_1.useState)(),
    _ref8 = _slicedToArray(_ref7, 2),
    syncStatus = _ref8[0],
    setSyncStatus = _ref8[1];
  var _ref9 = (0, react_2.useGetEnvChainId)(),
    baseEnv = _ref9.baseEnv;
  var _ref10 = (0, core_1.useEthers)(),
    account = _ref10.account,
    chainId = _ref10.chainId;
  var identity = (0, react_2.useGetContract)("Identity", true, "claim", constants_1.SupportedChains.FUSE);
  var identity2 = (0, react_2.useGetContract)("Identity", true, "claim", chainId);
  var _ref11 = (0, core_1.useCalls)([{
      contract: identity,
      method: "isWhitelisted",
      args: [account]
    }], {
      refresh: "never",
      chainId: constants_1.SupportedChains.FUSE
    }),
    _ref12 = _slicedToArray(_ref11, 1),
    fuseResult = _ref12[0];
  var _ref13 = (0, core_1.useCalls)([{
      contract: identity2,
      method: "isWhitelisted",
      args: [account]
    }].filter(function (_) {
      return _.contract && chainId != constants_1.SupportedChains.FUSE;
    }), {
      refresh: "never",
      chainId: chainId
    }),
    _ref14 = _slicedToArray(_ref13, 1),
    otherResult = _ref14[0];
  (0, react_1.useEffect)(function () {
    var whitelistSync = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isSynced, devEnv, backend;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return storage_1.AsyncStorage.getItem("".concat(account, "-whitelistedSync"));
            case 2:
              isSynced = _context2.sent;
              if (!(isSynced || (0, lodash_1.first)(fuseResult === null || fuseResult === void 0 ? void 0 : fuseResult.value) && (0, lodash_1.first)(otherResult === null || otherResult === void 0 ? void 0 : otherResult.value))) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", setSyncStatus(Promise.resolve(true)));
            case 5:
              if (!syncInProgress) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              // if whitelisted on fuse but not on celo then sync
              if ((0, lodash_1.first)(fuseResult === null || fuseResult === void 0 ? void 0 : fuseResult.value) && (0, lodash_1.first)(otherResult === null || otherResult === void 0 ? void 0 : otherResult.value) === false) {
                syncInProgress = true;
                devEnv = baseEnv === "fuse" ? "development" : baseEnv;
                backend = constants_1.Envs[devEnv].backend;
                setSyncStatus(fetch(backend + "/syncWhitelist/".concat(account)).then( /*#__PURE__*/function () {
                  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(r) {
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (!(r.status === 200)) {
                            _context.next = 7;
                            break;
                          }
                          _context.next = 3;
                          return r.json();
                        case 3:
                          storage_1.AsyncStorage.safeSet("".concat(account, "-whitelistedSync"), true);
                          return _context.abrupt("return", true);
                        case 7:
                          return _context.abrupt("return", false);
                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref16.apply(this, arguments);
                  };
                }()).catch(function () {
                  return false;
                }).finally(function () {
                  return syncInProgress = false;
                }));
              } else {
                setSyncStatus(Promise.resolve(false));
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function whitelistSync() {
        return _ref15.apply(this, arguments);
      };
    }();
    whitelistSync().catch(lodash_2.noop);
  }, [fuseResult, otherResult, account, setSyncStatus]);
  return {
    fuseWhitelisted: (0, lodash_1.first)(fuseResult === null || fuseResult === void 0 ? void 0 : fuseResult.value),
    currentWhitelisted: (0, lodash_1.first)(otherResult === null || otherResult === void 0 ? void 0 : otherResult.value),
    syncStatus: syncStatus
  };
};
exports.useWhitelistSync = useWhitelistSync;